import React, { useCallback, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./scenes/Dashboard/Dashboard";
import Layout from "./scenes/Layout";
import Login from "./components/auth/Login/Login";
import SignUp from "./components/auth/Sign-up/signup";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import CheckEmail from "./components/CheckEmail/CheckEmail";
import ProtectedRoute from "./ProtectedRoute";
import VerifyAccount from "./components/VerifyAccount/VerifyAccount";
import PublicRoute from "./PublicRoute";

import ChargingPoint from "./scenes/EnergyConsumption/ChargingPoint/ChargingPoint";
import CardDetails from "./scenes/AccountDetails/CardDetails/CardDetails";
import PaymentsHistory from "./scenes/AccountDetails/PaymentsHistory/PaymentsHistory";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import Energy from "./scenes/EnergyConsumption/Energy/Energy";
import ChargingSessions from "./scenes/chargingSessions/ChargingSessions";
import Tariffs from "./scenes/Tariffs/Tariffs";
import ChargingPointPairing from "./scenes/EnergyConsumption/ChargingPoint/ChargingPointPairing";
import DummyPage from "./scenes/DummyPage/DummyPage";
import AboutUs from "./scenes/AboutUs/AboutUs";

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isPromptShown, setIsPromptShown] = useState(false);
  const [userDismissed, setUserDismissed] = useState(false);
  const [deviceId, setDeviceId] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      const userAgent = navigator.userAgent;
      const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
      const isNativeApp = /rsp\/v/i.test(userAgent);
      setTimeout(function() {
        if (!isPromptShown && !userDismissed && isMobile && !isNativeApp && (deviceId !== "E6E3F5DF8-0" && deviceId !== "F55OH9-1")) {
          console.log("Calling intall prompt");
          setDeferredPrompt(event);
        }
      }, 5000);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, [isPromptShown, userDismissed, deviceId]);

  const handleInstallPrompt = useCallback(() => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome !== "accepted") {
          setUserDismissed(true);
        }
        setDeferredPrompt(null);
        setIsPromptShown(false);
      });
    }
  }, [deferredPrompt]);

  useEffect(() => {
    const triggerPrompt = () => {
      if (deferredPrompt && !isPromptShown && !userDismissed) {
        setIsPromptShown(true);
        handleInstallPrompt();
      }
    };

    window.addEventListener("click", triggerPrompt);

    return () => {
      window.removeEventListener("click", triggerPrompt);
    };
  }, [deferredPrompt, isPromptShown, userDismissed, handleInstallPrompt]);

  return (
    <>
      <Routes>
        <Route path="/login" element={<PublicRoute element={<Login />} />} />
        <Route path="/sign-up" element={<PublicRoute element={<SignUp />} />} />
        <Route
          path="/forgot-password"
          element={<PublicRoute element={<ForgotPassword />} />}
        />
        <Route
          path="/reset-password"
          element={<PublicRoute element={<ResetPassword />} />}
        />
        <Route
          path="/check-email"
          element={<PublicRoute element={<CheckEmail />} />}
        />
        <Route
          path="/verify-account"
          element={<PublicRoute element={<VerifyAccount />} />}
        />
        <Route
          path="/demo-page"
          element={<PublicRoute element={<DummyPage />} />}
        />

        {/* Protected Routes */}
        <Route path="/" element={<ProtectedRoute element={<Layout />} />}>
          <Route index element={<Dashboard setDeviceId={setDeviceId}/>} />
          {/* Energy Consumption Routes */}
          <Route path="energy" element={<Energy />} />

          <Route path="charging-sessions" element={<ChargingSessions />} />
          <Route path="tariffs" element={<Tariffs />} />

          <Route path="devices" element={<ChargingPoint />} />
          <Route
            path="/charge-points/pair-device/:chargePointId"
            element={<ChargingPointPairing />}
          />

          {/* Account details routes */}
          <Route path="card-details" element={<CardDetails />} />
          <Route path="payment-history" element={<PaymentsHistory />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>

        {/* Redirect all unknown paths to /login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}

export default App;
